// extracted by mini-css-extract-plugin
module.exports = {"link":"breadcrumbs_link__1wDk_","linkSizeS":"breadcrumbs_linkSizeS__2opNR","linkSizeM":"breadcrumbs_linkSizeM__2gzly","linkLast":"breadcrumbs_linkLast__1AorP"};